<template>
	<div :class="['quote-block', cardColor]" :id="id">
		<div class="quote-block__title">{{ title }}</div>
		<PictureImg v-if="image" :media="image" class="quote-block__image" />
		<div class="quote-block__text" v-html="quoteText"></div>
		<div class="quote-block__author">
			- {{ authorName }},
			{{ authorTitle }}
		</div>
	</div>
</template>

<script setup>
const props = defineProps({
	fields: { type: Object, required: true },
	rendering: { type: Object, required: false },
});

const id = computed(() => props.fields?.id?.value);
const title = computed(() => props.fields?.title?.value);
const image = computed(() => props.fields?.image?.value);
const quoteText = computed(() => props.fields?.quoteText?.value);
const authorName = computed(() => props.fields?.authorName?.value);
const authorTitle = computed(() => props.fields?.authorTitle?.value);
const cardColor = computed(() => props.fields?.cardColor?.value);
</script>

<style lang="scss">
.quote-block {
	padding: var(--spacing-7, 56px) var(--spacing-2, 16px);
	border-radius: 30px 30px 0 0;

	.quote-block__title {
		font-size: var(--text-3xl, 40px);
		font-style: normal;
		font-weight: 900;
		line-height: 120%;
		text-transform: uppercase;
		padding: var(--spacing-2, 16px) 0 30px;
	}

	.quote-block__image img {
		padding: 0;
	}

	.quote-block__text {
		font-size: var(--text-2xl, 32px);
		font-style: normal;
		font-weight: 400;
		line-height: 120%;
	}

	.quote-block__author {
		font-size: var(--text-base, 16px);
		font-style: normal;
		font-weight: 400;
		line-height: 140%;
		padding-bottom: var(--spacing-2, 16px);
	}

	&,
	&.default,
	&.primary {
		background-color: var(--primary-color, #000);
		color: var(--color-white, #fff);
	}

	&.secondary {
		background-color: var(--secondary-color, #000);
		color: var(--color-white, #fff);
	}

	&.tertiary {
		background-color: var(--tertiary-color, #000);
		color: var(--color-white, #fff);
	}

	&.grey {
		background-color: var(--color-grey, #282828);
		color: var(--color-white, #fff);
	}

	&.white {
		background-color: var(--color-white, #fff);
		color: var(--color-black, #000);
	}
}
</style>
